/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { sendEmailToSupport } from '../fn/contact/send-email-to-support';
import { SendEmailToSupport$Params } from '../fn/contact/send-email-to-support';


/**
 * Služby pre kontaktný formulár
 */
@Injectable({ providedIn: 'root' })
export class ContactService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sendEmailToSupport()` */
  static readonly SendEmailToSupportPath = '/client/sendEmailToSupport';

  /**
   * Služba pre posielanie emailov.
   *
   * Služba na posielanie emailov na kontaktné osoby definované v admin rozhraní
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendEmailToSupport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendEmailToSupport$Response(params: SendEmailToSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return sendEmailToSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Služba pre posielanie emailov.
   *
   * Služba na posielanie emailov na kontaktné osoby definované v admin rozhraní
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendEmailToSupport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendEmailToSupport(params: SendEmailToSupport$Params, context?: HttpContext): Observable<boolean> {
    return this.sendEmailToSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
